// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"531":"fc86fa72","575":"24188f78","812":"a3cccbf2","832":"a3cccbf2"}[chunkId] + ".chunk.css";
};